import store from '../store'
import filter from 'lodash/filter'

export function getMessagesForMediaNode(nodeId) {	
	const state = store.getState()
	const nodeMessages= filter(state.messages, {'selection_node_id':`${nodeId}`})
	return nodeMessages
}

